export default __webpack_public_path__ + "static/media/Paid-bro.7c961604.svg";